<template>
  <div v-if="invoice.order" class="ls-theme-cyanogen container subscribe-wrapper">
    <header class="main-header ls-md-margin-top">
      <h1 class="trade-name" >{{ basicSeller.trade_name || basicSeller.name }}</h1>
      <h3 class="subtitle">{{ $t('payments.messages.finalized_payment') }}</h3>
    </header>
    <div class="checkout-details col-md-12">
      <div class="col-md-8 col-sm-6 ls-no-padding-left">
        <h4 class="green ls-txt-center ls-md-margin-bottom">{{ $t('payments.messages.successful_payment') }}</h4>
        <hr>
        <ul class="payment-info">
          <li class="ls-md-margin-bottom" v-for="step in steps">
            <div>
              <i :class="step.icon" aria-hidden="true"></i>
              <p class="ls-no-margin ls-txt-justify" v-html="step.description">{{ step.description }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md-4 col-xs-12 col-sm-12 col-sm-6 ls-no-padding-left ls-no-padding-right">
        <div class="full-height ls-no-padding-left ls-no-padding-right">
          <invoice-details class="ls-md-margin-bottom" :invoice="invoice"></invoice-details>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import money from 'src/utils/money'
  import InvoiceDetails from './components/InvoiceDetails.vue'

  export default {
    props: ['message'],
    components: { InvoiceDetails },
    data () {
      return {
        money: money,
        finished: false,
        steps: [
          {
            description: this.$t('payments.messages.approved_by_card'),
            icon: 'fa fa-check-circle-o'
          },
          {
            description: this.$t('subscribe.messages.signature_will_only_be_approved_after_payment_confirmation'),
            icon: 'fa fa-file-text-o'
          }
        ]
      }
    },
    mounted () {
      this.redirectPayment()
    },
    methods: {
      redirectPayment () {
        if (!this.invoice.order) {
          this.$router.push('/payment/invoice/' + this.$route.params.id)
        }
      }
    },
    computed: {
      ...mapGetters(['basicSeller', 'invoice'])
    }
  }
</script>
<style lang="scss" scoped>
  .checkout-details {
    display: flex;
    justify-content: stretch;
    padding: 15px;
    @media screen and (max-width: 768px) {
      display: block;
      padding: 0;
      .order-box {
        margin-bottom: 40px;
      }
    }
  }
  .payment-details {
    .payment-icon {
      font-size: 36px;
      margin-right: 10px;
    }
  }
  .finished {
    max-width: 1206px;
    padding: 0 20px;
    margin: 0 auto;
    @media screen and (max-width: 768px) {
      padding: 0;
    }
  }
  .order-box {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    border-radius: 4px;
    border: 1px solid #dddddd;
    padding: 15px;
    > * {
      display: block;
      width: 100%;
    }
    @media screen and (max-width: 768px) {
      background: rgba(0, 0, 0, 0.11);
      border-radius: 0;
      text-align: center;
    }
  }
  .ls-btn {
    margin: 0 auto;
  }
  .btn {
    border: none;
    display: block;
    margin: 0 auto;
  }
  .bar-code {
    padding: 15px;
    font-size: 20px;
    width: 100%;
    color: #717787;
    text-align: center;
  }
  @media screen and (max-width: 768px) {
    .ls-box {
      -webkit-animation: cd-bounce-2 0.6s;
      -moz-animation: cd-bounce-2 0.6s;
      animation: cd-bounce-2 0.6s;
      border: none;
      padding: 0;
    }
  }
  .payment-info {
    flex-wrap: wrap;
    height: 100%;
    list-style: none;
    i {
      font-size: 40px;
      float: left;
      display: inline-block;
      padding: 0px 15px 0px 0px;
      @media screen and (max-width: 768px) {
        font-size: 28px;
        float: left;
        display: inline-block;
        padding: 0px 30px 27px 0px;
      }
    }
  }
  .ls-btn[disabled] {
    transform: scale(1.2);
  }
  .check-mark {
    width: 80px;
    height: 130px;
    margin: 0 auto;
  }
  .green {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// CardDone.vue?03f5ae8a